import { dispatch } from '../index'
import {
    REGISTRATION_SET_TOKEN,
    REGISTRATION_SET_DATA,
    REGISTRATION_SET_LOADING,
    REGISTRATION_SET_USER_ATTRIBUTES,
    REGISTRATION_SET_ERROR_MESSAGE,
    REGISTRATION_SHOW_CONFIRMATION_FORM,
    AUTH_SHOW_RESET_PASSWORD,
    LOGIN_SHOW_NEW_PASSWORD,
    AUTH_SHOW_LOGIN,
    AUTH_SET_PASSWORD_RESET_TOKEN,
    AUTH_SET_USER,
    REGISTRATION_SET_SHOW_POP_UP,
    REGISTRATION_SET_SHOW_HELP,
    REGISTRATION_SET_CREATE_OCCUPANCY,
    REGISTRATION_SET_SHOW_NOTIFICATION,
    SET_TERMS_ACCEPTED,
    SHOW_TERMS_OF_USE
} from '../actionTypes'

// Login
export const setShowNewPassword = (show) => dispatch({
    type: LOGIN_SHOW_NEW_PASSWORD,
    show
})

// General
export const setShowLogin = (show) => dispatch({
    type: AUTH_SHOW_LOGIN,
    show
})

export const setShowResetPassword = (show) => dispatch({
    type: AUTH_SHOW_RESET_PASSWORD,
    show
})

export const setPasswordResetToken = (token) => dispatch({
    type: AUTH_SET_PASSWORD_RESET_TOKEN,
    token
})

export const setUser = (user) => dispatch({
    type: AUTH_SET_USER,
    user
})

// Registration
export const setToken = (value) => dispatch({
    type: REGISTRATION_SET_TOKEN,
    value
})

export const setData = (data) => dispatch({
    type: REGISTRATION_SET_DATA,
    data
})

export const setLoading = (loading) => dispatch({
    type: REGISTRATION_SET_LOADING,
    loading
})

export const setUserAttributes = (attributes) => dispatch({
    type: REGISTRATION_SET_USER_ATTRIBUTES,
    attributes
})

export const setErrorMessage = (message) => dispatch({
    type: REGISTRATION_SET_ERROR_MESSAGE,
    message
})

export const showConfirmationForm = (username, code, resend) => dispatch({
    type: REGISTRATION_SHOW_CONFIRMATION_FORM,
    username,
    code,
    resend
})

export const setShowPopUp = (showPopUp) => dispatch({
    type: REGISTRATION_SET_SHOW_POP_UP,
    showPopUp
})

export const setShowHelp = (show) => dispatch({
    type: REGISTRATION_SET_SHOW_HELP,
    show
})

export const setShowNotifications = (show) => dispatch({
    type: REGISTRATION_SET_SHOW_NOTIFICATION,
    show
})

export const setCreateNewOccupancy = (value) => dispatch({
    type: REGISTRATION_SET_CREATE_OCCUPANCY,
    value
})

export const setTermsAccepted = (accepted) => dispatch({
    type: SET_TERMS_ACCEPTED,
    payload: accepted
})

export const showTermsOfUse = (show) => dispatch({
    type: SHOW_TERMS_OF_USE,
    payload: show
})